module.exports = "<div class=\"container my-2 d-print-none\">\n    <app-settings-table ></app-settings-table>\n</div>\n"